/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Birth_YearInputs */

const en_us2_profile_editors_birth_year = /** @type {(inputs: Profile_Editors_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year`)
};

const pt_br2_profile_editors_birth_year = /** @type {(inputs: Profile_Editors_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano`)
};

const es_419_profile_editors_birth_year = /** @type {(inputs: Profile_Editors_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Año`)
};

const pt_pt2_profile_editors_birth_year = /** @type {(inputs: Profile_Editors_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano`)
};

const fr_fr2_profile_editors_birth_year = /** @type {(inputs: Profile_Editors_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Année`)
};

const de_de2_profile_editors_birth_year = /** @type {(inputs: Profile_Editors_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahr`)
};

const it_it2_profile_editors_birth_year = /** @type {(inputs: Profile_Editors_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anno`)
};

/**
* | output |
* | --- |
* | "Year" |
*
* @param {Profile_Editors_Birth_YearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_birth_year = /** @type {((inputs?: Profile_Editors_Birth_YearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Birth_YearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_birth_year(inputs)
	if (locale === "es-419") return es_419_profile_editors_birth_year(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_birth_year(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_birth_year(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_birth_year(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_birth_year(inputs)
	return en_us2_profile_editors_birth_year(inputs)
});
export { profile_editors_birth_year as "profile-editors.birth_year" }